import React, { useState, useEffect } from 'react';
import Post from '../../../../utils/Post';
import { activeDialog } from '../../../../utils/Common';
import VainillaDialog from '../../../sharecomponents/vanilladialog';
import EditarUsuario from './EditarUsuario';
import GestionUsuariosSubseccion from './GestionUsuariosSubseccion';
import NuevoUsuarioForm from './NuevoUsuarioForm';
import AdministradorPerfilesSubseccion from './AdministradorPerfilesSubseccion';

const AdministradorDeUsuarios = (p) => {
    const [data, setdata] = useState({ usuarios: [], perfiles: [], ranchos: [], areas: [] });
    const [dialog, setdialog] = useState({ show: false });
    const [loader, setloader] = useState(false);
    const [nuevoUsuario, setnuevoUsuario] = useState(null);
    const [seccion, setseccion] = useState("USUARIOS");
    const [editUser, seteditUser] = useState(null);
    var counter = 0;
    useEffect(() => { getData(); }, []);
    const keyGen = () => { counter++; return (counter + " " + counter); }

    const getAPI = async (uri, data) => {
        let resp = await Post(uri, data, 'POST', setloader);
        if (resp.estatus) return resp;
        activeDialog(setdialog, resp.msj ? resp.msj : "Error de conexión", 'error', "Error");
        return false;
    }

    const getData = async () => {
        let resp = await getAPI("secure/users", {});
        if (!resp) return;
        if (resp) {
            setdata({ ...resp.data });
        }
    }

    const botonesSeleccion = (sec) => {
        return (
            <div className='w-45' style={{ minWidth: "150px" }}>
                <button className={`w-100 text-bold btn btn-${seccion === sec ? "warning" : "white shadow"} round-0 border`}
                    onClick={() => setseccion(sec)}>{sec}</button>
            </div>
        )
    }

    return (
        <div className='bw-1200 p-2 bg-light blur-s shadow-multi m-0 round-s relative dosis' >
            {nuevoUsuario && <NuevoUsuarioForm perfiles={data.perfiles} ranchos={data.ranchos} areas={data.areas} close={(refresh) => { if (refresh) getData(); setnuevoUsuario(null) }} getAPI={getAPI} />}
            {editUser && <EditarUsuario data={editUser} ranchos={data.ranchos} areas={data.areas} close={(refresh) => { if (refresh) getData(); seteditUser(null) }} />}
            <div className='row justify-content-evenly w-100 m-0 p-0'>
                <div className='w-100 mb-2 text-l text-center text-bold'> Administración de usuarios y tipos de perfil </div>
                {botonesSeleccion("USUARIOS")} {botonesSeleccion("PERFILES")}
                <div className='w-100'></div>
                {seccion === "USUARIOS" && <GestionUsuariosSubseccion data={data} keyGen={keyGen} getData={getData} getAPI={getAPI} seteditUser={seteditUser} setnuevoUsuario={setnuevoUsuario} />}
                {seccion === "PERFILES" && <AdministradorPerfilesSubseccion data={data} keyGen={keyGen} getData={getData} getAPI={getAPI} perfiles={data.perfiles} />}
            </div>
            {loader && <div className='blur-s w-100 h-100 round-m bg-white4' style={{ position: 'fixed', left: 0, top: 0 }}><div className='loader-local'></div></div>}
            <VainillaDialog data={dialog} />
        </div>
    )
}

export default AdministradorDeUsuarios;